import { RegFlowConfig, RoutePaths } from '@commerce-profile-webcomponents/sdk';
import { IRegErrorCardConfig } from '../components/RegistrationConfirmation/types/propTypes';

export const TextConstants = {
  ID_NUMBER_MIN: 2,
  ID_NUMBER_MAX: 10,
  NAME_MIN: 2,
  NAME_MAX: 100,
  CONTACT_NICKNAME_MAX: 50,
  ADDRESS_LINE_MAX: 100,
  POSTCODE_MIN: 5,
  POSTCODE_MAX: 5,
  BIRTHDAY_AGE_MIN: 10,
  CID_MIN: 7,
  CID_MAX: 13,
  MAX_AGE: 110,
};

export const ApiStatus = {
  BAD_REQUEST: 'BAD_REQUEST',
};
export const ErrorConstants = {
  GENERAL_ERROR_CODE: 'invalid-registration',
  GENERAL_LOADING_ERROR_CODE: 'data-loading-error',
  SPONSOR_FAILED: 'comregistrationas-sponsor-validation-failed',
  SPONSOR_BLOCK_VALIDATION_ERROR: 'SPONSOR_BLOCK_VALIDATION_ERROR',
  PROFILE_GENERAL_ERROR_CODE: 'general',
  CID_EXPIRED_CODE: 'comregistrationas-cid-expired',
  EMAIL_NOT_UNIQUE: 'comprofileas-email-not-unique',
  PHONE_NOT_UNIQUE: 'comprofileas-phone-not-unique',
  ACCOUNT_EMAIL_NOT_UNIQUE: 'comaccountas-email-not-unique',
  ACCOUNT_PHONE_NOT_UNIQUE: 'comaccountas-phone-not-unique',
  REGISTRATION_INTERNAL_SERVER_ERROR: 'comregistrationas-internal-server-error',
};
export const ErrorStatusConstants = {
  STATUS_503: 503,
  STATUS_504: 504,
};
export const ProjectionParam = {
  FULL: 'FULL',
  DOCUMENTS: 'DOCUMENTS',
};

export const AccountLifeCycleConstants = {
  RENEWAL_CONFIG: 'renewal',
  ALLOW_RENEWAL: 'allowRenewal',
  ALLOW_UPGRADE: 'allowUpgrade',
  ALLOW_DOWNGRADE: 'allowDowngrade',
  ALLOW_AUTO_RENEWAL: 'allowAutoRenewal',
  USE_PROFILE_CART: 'useProfileCart',
  RENEWAL_GRACE_PERIOD: 'renewalGracePeriodMonths',
  RENEWAL_WINDOW_PERIOD: 'renewalWindowPeriodMonths',
};

export const AccountLifeCycleKitType = {
  E_KIT: 'eKit',
  P_KIT: 'pKit',
};

export const AccountTypeCode: Record<string, string> = {
  BUSINESS_OWNER: 'abo',
  MEMBER: 'member',
};

export const AssetPath = {
  ERROR_IMAGE: '/images/CheckoutPageError.svg',
  NO_RESULT_IMAGE: '/images/OrderHistoryEmptyResult.svg',
  STARTER_KIT_IMAGE: 'icons/AmwayActive.svg',
};

// To control feature that available in different environment
// Use case: new feature availble in dev env but not in qa env
export const MARKET_ENV_TYPE = {
  GLOBAL_QA: 'global-qa',
  GLOBAL_DEV: 'global-dev',
  THA_PROD: 'tha-prod',
  THA_UAT: 'tha-uat',
  THA_QA: 'tha-qa',
};

export const DEFAULT_LOCALE = 'en';
export const DEFAULT_ROTATION = 90;

export const EDITOR_ASPECT_RATIO = {
  // (w/h)
  CID: 1.602 / 1, //width is more than length
  HOUSE_REGISTRATION: 0.871 / 1,
  PASSPORT: 1 / 1.41,
};

export const CANVAS_DEFAULT_SIZE = {
  scale: 1,
  rotate: 0,
  slideRotation: DEFAULT_ROTATION,
  borderRadius: 0,
  height: 200,
  width: 200,
};

export const COMPELTE_ANGLE = 360;
export const MASTER_DATA_PK = {
  USER_PASSPORT: 'personalIdPassportRecordNumber',
  USER_CID: 'personalIdCidRecordNumber',
  SPOUSE_CID: 'spouseCidRecordNumber',
  SPOUSE_PASSPORT: 'spousePassportRecordNumber',
};

export const ADDRESS_FIELDS = {
  ADDRESS_LINE_ONE: 'addrLineOne',
  ADDRESS_LINE_TWO: 'addrLineTwo',
  ADDRESS_LINE_THREE: 'addrLineThree',

  // LATAM
  ADDRESS_TYPE_OTHER: 'addressTypeOther',
  MAIN_ROAD: 'mainRoad',
  SIDE_LINE: 'sideline',
  NUMBER: 'houseNumber',

  CONTACT_NICKNAME: 'contactNickname',
  RECIPIENT_FIRST_NAME: 'recipientFirstName',
  RECIPIENT_LAST_NAME: 'recipientLastName',
  DELIVERY_INSTRUCTIONS: 'deliveryInstructions',
  // GUIDED INPUT
  STATE: 'state',
  DISTRICT: 'district',
  SUB_DISTRICT: 'subDistrict',
  POSTAL_CODE: 'postalCode',
  ADDRESS_TYPE: 'addressType',
  // OTHER FIELD
  COUNTRY_CODE: 'countryCode',
  // SHIPPING
  SHIPPING_DETAILS: 'shipping-details',
};

export const UpgradeDocumentType = {
  UPLOAD: 'upload',
  SIGNATURE: 'signature',
};

export const ERROR_GENERIC_MESSAGE = {
  headline: 'profile.ApiErrorModal.genericError.headline',
  body: 'profile.ApiErrorModal.genericError.body',
};
export const CONSTANTS = {
  IMAGE_MAX_SIZE: 6 * 1024 * 1024,
  IMAGE_HEIGHT: 140,
  IMAGE_WIDTH: 240,
  TIME_COVERSION: 1000 * 3600 * 24,
  VALID_FILE_TYPES: ['image/jpeg', 'image/png'],
};

export const DATE_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
export const NUMBER_REGEX = /^[0-9]+$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const RegistrationErrorCardConfig: IRegErrorCardConfig = {
  'comregistrationas-submit-validation-error': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    desc: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongDesc',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-unknown-error': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-blacklist-error': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    desc: 'profile.ErrorCard.RegErrorCardConfig.blackListDesc',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-account-already-exists': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    desc: 'profile.ErrorCard.RegErrorCardConfig.accountAlreadyExistDesc',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrations-cooling-period-error': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    desc: 'profile.ErrorCard.RegErrorCardConfig.coolingPeriodDesc',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-account-exists': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    desc: 'profile.ErrorCard.RegErrorCardConfig.accountExistDesc',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-internal-server-error': {
    title: 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
  default: {
    title: 'profile.common.errorHeading',
    desc: 'profile.common.pleaseTryAgain',
    primaryButtonLabel: 'profile.ErrorCard.RegErrorCardConfig.goToHomePageButton',
    primaryRedirectUrl: RoutePaths.HOME,
  },
};

export const DATE_FORMAT = {
  'YYYY-MM-DD': 'YYYY-MM-DD',
  'MM/DD/YYYY': 'MM/DD/YYYY',
  'DD/MM/YYYY': 'DD/MM/YYYY',
} as const;

export const USER_DETAIL_STEP_BASE_FIELDS = [
  'personalIdType',
  'personalIdRecordNumber',
  'firstName',
  'lastName',
  'citizenshipCountry',
  'email',
  'phone',
  'userName',
  'secondaryContact',
  'termsAndConditionCheckbox',
  'gender',
  'birthDate',
  'dob',
];

export const USER_DETAIL_STEP_ADDITIONAL_FIELDS = [
  // other subForm fields
  ...USER_DETAIL_STEP_BASE_FIELDS,
  'taxRegime',
  'sponsor',
  'billingAddress',
  'personalIdDocument',
];

export const REG_FLOW_WISE_FIELD = {
  [RegFlowConfig.SelfInitiatedFlow]: [...USER_DETAIL_STEP_ADDITIONAL_FIELDS, 'password'], // this will be used for most of the flows
  [RegFlowConfig.AboLedFlow]: USER_DETAIL_STEP_ADDITIONAL_FIELDS,
  [RegFlowConfig.OpsLedFlow]: [...USER_DETAIL_STEP_ADDITIONAL_FIELDS, 'employeeId'],
  [RegFlowConfig.CoApplicantFlow]: [...USER_DETAIL_STEP_BASE_FIELDS, 'password', 'personalIdDocument'],
};

export const SPONSOR_PREDEFINED_FLOW = [RegFlowConfig.AboLedFlow, RegFlowConfig.ShareBarFlow] as RegFlowConfig[];

export const FLOWS_WITH_POSSIBLE_SPONSOR = [
  RegFlowConfig.SelfInitiatedFlow,
  RegFlowConfig.GuestCheckoutFlow,
] as RegFlowConfig[];

export const RANDOM_SPONSOR_NAME = 'Random';

export const VALIDATION_VALID_STRING = 'VALID';

// To remove
export const PAYMENT_SUMMARY_TYPE = {
  CARD: 'card',
  BANK: 'bank',
};

export const CONTRACT_NAME = 'contracts';
export const DOCUMENT_NAME = 'documents';

export const COAPP_STEPS = {
  P1_ID_STEP: 'coApplicantIdStep',
  P1_DOCUMENT_UPLOAD_STEP: 'coApplicantDocumentUploadStep',
  P1_INVITE_STEP: 'coApplicantInviteStep',
  P1_RESEND_STEP: 'coApplicantReInviteStep',
  P2_ID_STEP: 'coApplicantIdVerificationStep',
  P2_USER_DETAIL_STEP: 'coApplicantUserDetailsStep',
};

export const ANONYMOUS = 'Anonymous';

export const SHARECODE_ATTRIBUTES = 'sharecodeAttributes';

export const SHAREBAR_FLOWS = {
  MEPANEL: 'mepanel',
  PDP: 'pdp',
  MYLIST: 'mylist',
  MYSHOP: 'myshop',
};

export const FLOWS_WITH_PHASE_TWO = [RegFlowConfig.AboLedFlow, RegFlowConfig.CoApplicantFlow];

export const COAPP_FIELDS_LOGGEDIN = [
  'personalIdType',
  'personalIdRecordNumber',
  'userName',
  'termsAndConditionCheckbox',
  'email',
  'phone',
  'secondaryContact',
];

export const COAPP_REGISTRATION_STEP_NAME = 'coappUserDetailsStep';

export const APPLICATION_SOURCE = 'nextgen';

export const COAPP = {
  Registration: 'registration',
  IdStep: 'idStep',
};

export const CONTACT_TASKS = ['REVERIFY_EMAIL', 'REVERIFY_PHONE'];

export const CONTACT_TASK_KEY = 'check-tasks-later';

export const TEALIUM_REGISTRATION_EVENTS = {
  OTP_VERIFIED: 'registration_otp_verified',
  LEADS_NOT_FOUND: 'registration_leads_not_found',
  COAPP_RESEND_LINK: 'coapp_resend_link',
  COAPP_ADD_PARTNER: 'coapp_add_partner',
};
